// React Thirty Party Library
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Layout as LayoutAntd } from "antd";
import { useNavigate } from "react-router";

// Constants Library
import * as CONFIG from "../../../config";
import { ROUTES, FEATURE, COMMON_FEATURES, ROOT_CONSTANT } from "../../../constants";

// Components Library
import SidebarMenu from "./SidebarMenu";
import Logo from "./Logo";
import ConfirmLogout from "../../../components/ButtonModal/modules/ConfirmLogout";

// Handler Library

// Services Library
import { REDUX as REDUX_UTIL } from "../../../services/util"

// Redux Actions
import { v1_user } from "../../../services/redux/actions";

// Styles Library
import "./index.css";

const { reduxStoreWrapper } = REDUX_UTIL
const { Sider } = LayoutAntd;

const {
  FEATURE_MENU_ITEMS_OBJ,
  FEATURE_MENU_ITEMS_COMP_LAYER_FIRST,
  FEATURE_MENU_ITEMS_COMP_LAYER_SECOND
} = FEATURE;

const { MODULE_ROUTE } = ROUTES;

const { FEATURE_TYPE } = COMMON_FEATURES;

const { user_sign_out_request } = v1_user;

const LayoutSidebar = ({ collapsed }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [isModalOpen, setIsModalOpen] = useState(false);

  const user = useSelector(reduxStoreWrapper("user"))

  const handleModal = (st) => {
    setIsModalOpen(st);
  };

  const onClickConfirmLogout = () => dispatch(user_sign_out_request());

  const SIClickHander = (sidebarItem) => {
    const { key } = sidebarItem;

    const { type } = FEATURE_MENU_ITEMS_OBJ[key];

    switch (type) {
      case FEATURE_TYPE.ROUTE: {
        navigate(MODULE_ROUTE[key]);
        break;
      }
      case FEATURE_TYPE.LOGOUT: {
        handleModal(true);
        break;
      }
      default: {
        break;
      }
    }

    return 1;
  };
  const role = user.uroleid
  const sidebarItems = [
    ...FEATURE_MENU_ITEMS_COMP_LAYER_FIRST(role),
    {
      key: "dvider",
      label: "dvider",
      icon: <></>,
      type: "divider", 
      routeType: "divider",
    },
    ...FEATURE_MENU_ITEMS_COMP_LAYER_SECOND,
  ];

  return (
    <>
      <Sider
        style={{
          height: "100vh",
          backgroundColor: "#0E2483",
          overflowY: "hidden",
          position: "fixed",
          zIndex: "1",
        }}
        width={"30vh"}
        trigger={null}
        collapsible
        collapsed={collapsed}
      >
        <Logo collapsed={collapsed} />
        <SidebarMenu
          sidebarItems={sidebarItems}
          onClick={(item) => SIClickHander(item)}
        />
        <div className="version">
          V <i>{CONFIG.APP_INFO.APP_VERSION}</i>
        </div>
      </Sider>
      <ConfirmLogout
        isModalOpen={isModalOpen}
        setIsModalOpen={() => setIsModalOpen(false)}
        onClick={() => onClickConfirmLogout()}
      />
    </>
  );
};

export default LayoutSidebar;
